import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../components/commonDesign/SydModal'
import CopyScheduleInternalForm from './form'

const CopyScheduleInternalDialog = React.forwardRef(function CopyScheduleInternalDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (schedule) => setDialogState({
      open: true,
      processing: false,
      schedule
    })
  }), [setDialogState])

  return (
    <SydModal
      title={dialogState.schedule?.isDigest ? 'Copy Digest' : 'Copy Scheduled Prompt'}
      open={dialogState.open}
      onClose={close}
      size='sm'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <CopyScheduleInternalForm
            schedule={dialogState.schedule}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

CopyScheduleInternalDialog.propTypes = {
  onComplete: PropTypes.func
}

CopyScheduleInternalDialog.defaultProps = {
  onComplete: () => {}
}

export default CopyScheduleInternalDialog
